import { createAsyncThunk  } from '@reduxjs/toolkit';
import { errorGlobal, successGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';

import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';


// Fetch user's clients
export const fetchClients = createAsyncThunk(
    'waste/fetchClients',
    async(category, { dispatch }) => {
        try{
            const query = category ? `?category=${encodeURIComponent(category)}` : '';
            const request = await axios.get(`/api/client/fetch${query}`, getAuthHeader());
            return request.data;
        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
)

// Add Waste to evidence sheet
export const addWaste = createAsyncThunk(
    'waste/addWaste',
    async(waste, { dispatch }) => {
        try {
            const request = await axios.post(`/api/evidencesheet/${waste.currentEvidenceListId}/create-waste`, waste, getAuthHeader());
            dispatch(successGlobal('Odpad bol úspešne pridaný.'));
            return request.data;
        } catch(error) {
            // dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            dispatch(errorGlobal('Odpad sa nepodarilo pridať.'))
            throw error;
        }
    }
)

// Edit Waste in Evidence sheet
export const editWaste = createAsyncThunk(
    'waste/editWaste',
    async(waste, { dispatch }) => {
        try {
            const request = await axios.patch(`/api/evidencesheet/${waste.currentEvidenceListId}/update-waste`, waste, getAuthHeader());
            dispatch(successGlobal('Odpad bol úspešne upravený.'));
            return request.data;
        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        } 
    }
)

// Show Waste by Id
export const showWasteById = createAsyncThunk(
    'waste/showWasteById',
    async ({ evidenceList, branchId, wasteId }, { dispatch }) => {
        try {
            
            const request = await axios.get(`/api/evidencesheet/${evidenceList}/detail-waste`, {
                params: {
                    branchId: branchId,
                    wasteId: wasteId
                },
                ...getAuthHeader() // Predpokladám, že máte funkciu getAuthHeader na získanie hlavičky pre autentifikáciu
            });

            return request.data;
        } catch (error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

// Show Waste in evidence sheet
export const showWaste = createAsyncThunk(
  'waste/showWaste',
  async ({ evidenceListId, branchId, page, limit, year, quarter }, { dispatch }) => {
    try {
      const response = await axios.get(`/api/evidencesheet/${evidenceListId}/show-waste`, {
        params: { branchId, page, limit, year, quarter },
        ...getAuthHeader()
      });

      const sortedData = response.data.data.slice().sort((a, b) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);

        const dayA = new Date(dateA.getFullYear(), dateA.getMonth(), dateA.getDate());
        const dayB = new Date(dateB.getFullYear(), dateB.getMonth(), dateB.getDate());

        if (dayA.getTime() > dayB.getTime()) return -1; // novší dátum hore
        if (dayA.getTime() < dayB.getTime()) return 1;

        // Ak je rovnaký dátum: príjem (income > 0) pred výdajom
        const isIncomeB = a.income > 0 ? 0 : 1;
        const isIncomeA = b.income > 0 ? 0 : 1;

        return isIncomeA - isIncomeB;
      });

      return {
        ...response.data,
        data: sortedData
      };
    } catch (error) {
      dispatch(errorGlobal(error.response?.data?.message || 'Chyba pri načítaní odpadu'));
      throw error;
    }
  }
);

// Remove Waste in evidence sheet
export const removeWaste = createAsyncThunk(
    'waste/removeWaste',
    async({wasteId, evidenceListId, branchId}, { dispatch }) => {
        try {
            const request = await axios.delete(`/api/evidencesheet/${evidenceListId}/delete-waste`, {
                params: { 
                    branchId: branchId,
                    wasteId: wasteId,
                    evidenceList: evidenceListId,
                   

                }, 
                ...getAuthHeader()
            });
            return { data: request.data, status: request.status };
        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        } 
    }
);

export const generateIncome = createAsyncThunk(
    'waste/generateIncome',
    async({branchId, evidenceListId, year}, {dispatch}) => {
       
        try {

            const response = await axios.post(
                `/api/evidencesheet/${evidenceListId}/generate-incomes`,
                {
                    branchId,
                    year
                },
                getAuthHeader()
            );

            dispatch(successGlobal('Vznik/príjem bol úspešne vygenerovaný.'));
            return response.data;

        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);

export const generateMonthlyIncome = createAsyncThunk(
    'waste/generateMonthlyIncome',
    async(values, {dispatch}) => {
        try {

            const evidenceListId = values.currentEvidenceListId;
            const branchId = values.branchId;
            const fromDate = values.fromDate;
            const date = values.date;
            const weight = values.weight;
            const warehouse = values.warehouse;
            const container = values.container;

            const response = await axios.post(
                `/api/evidencesheet/${evidenceListId}/generate-income-months`,
                {
                    branchId,
                    fromDate,
                    date,
                    weight,
                    warehouse,
                    container
                },
                getAuthHeader()
            );

            dispatch(successGlobal('Mesačný vznik bol úspešne vygenerovaný.'));
            return response.data;

        } catch(error) {
            dispatch(errorGlobal(error.response?.data?.message || 'Nastala chyba. Skúste to prosím znova.'));
            throw error;
        }
    }
);